// Deterministic color per team name, hash-based so new roles get a color automatically
const TEAM_COLOR_PALETTE = [
    '#3b82f6',
    '#10b981',
    '#8b5cf6',
    '#9ca3af',
    '#f59e0b',
    '#14b8a6',
    '#e06c4e',
    '#4e7ec2',
    '#a05eb5',
    '#c45a8d'
];

function hashString(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0;
    }
    return Math.abs(hash);
}

// Pinned colours: TC's hash collides with GP's green, and Ortho reads as purple.
const TEAM_COLOR_OVERRIDES: Record<string, string> = { TC: '#f97316', Ortho: '#8b5cf6' };

export function getTeamColor(name: string): string {
    return (
        TEAM_COLOR_OVERRIDES[name] ??
        TEAM_COLOR_PALETTE[hashString(name) % TEAM_COLOR_PALETTE.length]
    );
}
